import instance, { axiosParams } from 'services';
import {
  removeAuthToken,
  removeNextStep,
  removeRefreshToken,
  updateAuthToken,
  updateRefreshToken,
} from 'utils/token-handler';

import {
  ICurrenUserDataResponse,
  IForgetResetPassword,
  IRegisterUserCompanyInfoRequest,
  IRegisterUserCompanyInfoResponse,
  IRegisterUserInfoRequest,
  IRegisterUserInfoResponse,
  IUserCredentials,
  IUserLoginResponse,
} from './types';
import axios from 'axios';

export const updateTokenAndReturnData = (response: any) => {
  if (response.data.accessToken) {
    updateAuthToken(response?.data?.accessToken);
  }

  if (response?.data?.refreshToken) {
    updateRefreshToken(response?.data?.refreshToken);
  }

  if (response?.data?.nextStep) {
    localStorage.setItem('nextStep', response?.data?.nextStep);
  }

  return response.data;
};

export const registerUserPersonalInfo = async (
  userInfo: IRegisterUserInfoRequest
): Promise<IRegisterUserInfoResponse> => {
  removeAuthToken();

  const response = await instance.post('api/v1/auth/signup/personal-info', {
    ...userInfo,
  });

  return updateTokenAndReturnData(response);
};

export const registerUserCompanyInfo = async (
  userInfo: IRegisterUserCompanyInfoRequest
): Promise<IRegisterUserCompanyInfoResponse> => {
  const response = await instance.post('/api/v1/auth/signup/company-info', {
    ...userInfo,
  });

  return updateTokenAndReturnData(response);
};

export const verifyEmail = async (
  code: string
): Promise<IRegisterUserCompanyInfoResponse> => {
  const response = await instance.post('/api/v1/auth/verify-email', {
    code,
  });

  return updateTokenAndReturnData(response);
};

export const loginClient = async (
  credentials: IUserCredentials
): Promise<IUserLoginResponse> => {
  removeAuthToken();
  const response = await instance.post('/api/v1/auth/signin', {
    ...credentials,
  });

  return updateTokenAndReturnData(response);
};

export const resetPassswordSendCode = async (
  email: string
): Promise<string> => {
  removeAuthToken();

  const response = await instance.post(
    '/api/v1/auth/reset-password/send-code',
    {
      email,
    }
  );

  return updateTokenAndReturnData(response);
};
export const resetPassswordVerifyCode = async (
  data: IForgetResetPassword
): Promise<string> => {
  const response = await instance.post(
    '/api/v1/auth/reset-password/verify-code',
    {
      ...data,
    }
  );

  return updateTokenAndReturnData(response);
};
export const resetForgetPassword = async (
  password: string
): Promise<string> => {
  const response = await instance.post('/api/v1/auth/reset-password', {
    password,
  });

  return updateTokenAndReturnData(response);
};

export const sendCode = async (): Promise<string> => {
  const response = await instance.post(
    '/api/v1/auth/verify-email/send-code',
    {}
  );

  return updateTokenAndReturnData(response);
};

export const refreshToken = async (
  refreshToken: string
): Promise<IUserLoginResponse | null> => {
  try {
    const response = await axios.post(
      '/api/v1/auth/refresh-token',
      { refreshToken },
      {
        ...axiosParams,
      }
    );

    if (
      response.data &&
      response.data.accessToken &&
      response.data.accessToken !== 'undefined'
    ) {
      const newToken = response.data.accessToken;
      updateAuthToken(newToken);

      return response.data;
    }
  } catch (error) {
    removeRefreshToken();
    removeAuthToken();
    removeNextStep();
    window.location.href = '/login';
    return null;
  }
};

export const getCurrentUser = async (): Promise<ICurrenUserDataResponse> => {
  const response = await instance.get('/api/v1/users/me');

  return updateTokenAndReturnData(response);
};
